module.exports = __webpack_public_path__ + "media/bootstrap-icons/truck-flatbed-6e8b63d6.svg";